import {
  all,
  call,
  put,
  putResolve,
  takeLatest
} from 'redux-saga/effects';
import getOptions from '@gcc/configurator/dist/api/optionsApi';
import { getSettings } from '@gcc/configurator/dist/settings';
import { executeImmediateRules } from '@gcc/configurator/dist/actions/rulesActions';
import { loadOptionsSuccess } from '@gcc/configurator/dist/actions/optionActions';
import { normalizeOptionData } from '@gcc/configurator/dist/modules/mapping';
import {
  beginAjaxCall,
  beginAjaxLoad,
  configuratorLoad,
  configuratorLoadFailure,
  configuratorLoadSuccess,
  endAjaxLoad,
} from '@gcc/configurator/dist/actions/ajaxStatusActions';
import omit from 'lodash/omit';
import { loadConfiguratorOptions, savePricingDetailsFromThd } from '../actions';
import safeSaga from './safeSaga';
import { persistDesign } from '../actions/actionCreators';
import { storeById } from '../api/storeInfoApi';
import { setStore } from '../actions/store';
import { getRegionalSelections } from '../api/getRegionalSelections';

function* loadConfigOptions(action) {
  const storeNumber = action.payload.padStart(4, '0');

  yield all([
    put(configuratorLoad()),
    put(beginAjaxLoad('Loading Options')),
    put(beginAjaxCall())
  ]);
  const { onLoadSuccess, onLoadFailure } = getSettings();
  try {

    const resp = yield call(getOptions);
    const { data } = resp;
    if (data) {
      const normalized = normalizeOptionData(data.groups);
      // any product data other than groups/options/choices
      // (brand, productType, siteProductName, mainImageUrl, productId, isVisualized)
      const productInfo = omit(data, 'groups');

      yield put(loadOptionsSuccess(normalized, {}, productInfo));
      yield put(executeImmediateRules());
      if (Number.isFinite(+storeNumber)) {
        const response = yield call(storeById, +storeNumber);
        // eslint-disable-next-line max-len
        const regionalSelections = yield getRegionalSelections(productInfo.productId, storeNumber, response.address.zipcode);
        const store = {
          isStoreEnabled: true,
          storeNumber: +storeNumber,
          zipcode: response.address.zipcode,
          storeInfo: {
            storeId: storeNumber,
            name: response.name,
            distance: response.distance,
            phone: response.phone,
            address: response.address,
          },
          pilot: true,
          regionalSelections,
        };
        yield put(setStore({ storeFromDesign: store }));
        // yield put(savePricingDetailsFromThd({}));
      }
      yield put(configuratorLoadSuccess);
      if (onLoadSuccess) {
        onLoadSuccess();
      }
      yield putResolve(persistDesign);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(`LoadConfiguratorOptions failed with ${err.message}`);
    if (onLoadFailure) {
      onLoadFailure();
    }
    yield put(configuratorLoadFailure);
  }
  yield put(endAjaxLoad());
}

export function* loadConfiguratorOptionsSaga() {
  yield takeLatest(loadConfiguratorOptions.toString(), safeSaga(loadConfigOptions));
}
